import React from 'react';

const ButtonIcon = ({children, className, onClick}) => {
    return (
        <button className={`rounded-full bg-white/20 p-4 ${className || ""}`} onClick={onClick}>{children}</button>
    )
}

export default ButtonIcon